export const ROOMS_COLORS_DESCRIPTION = (t: (id: string) => string) => {
  return [
    {
      id: '1',
      color: '#ffa822',
      label: t('1room'),
    },
    {
      id: '2',
      color: '#134e6f',
      label: t('2room'),
    },
    {
      id: '3',
      color: '#ff6150',
      label: t('3room'),
    },
    {
      id: '4',
      color: '#1ac0c6',
      label: t('4room'),
    },
    {
      id: '5',
      color: '#dee0e6',
      label: t('5OrMoreRoom'),
    },
  ];
};

export const COMPARTMENTS_COLORS_DESCRIPTION = (t: (id: string) => string) => {
  return [
    {
      id: '1',
      color: '#ADC5D6',
      label: t('livingRoom'),
    },
    {
      id: '2',
      color: '#798da2',
      label: t('bathroom'),
    },
    {
      id: '4',
      color: '#b9dddc',
      label: t('bedroom'),
    },
    {
      id: '5',
      color: '#e4dcbe',
      label: t('terrace'),
    },
    {
      id: '6',
      color: '#798da2',
      label: t('wc'),
    },
  ];
};

// export const COMPARTMENTS_COLORS_DESCRIPTION = (t: (id: string) => string) => {
//   return [
//     {
//       id: '1',
//       color: '#ffa822',
//       label: t('livingRoom'),
//     },
//     {
//       id: '2',
//       color: '#134e6f',
//       label: t('bathroom'),
//     },
//     {
//       id: '3',
//       color: '#ff6150',
//       label: t('kitchen'),
//     },
//     {
//       id: '4',
//       color: '#A4508B',
//       label: t('bedroom'),
//     },
//     {
//       id: '5',
//       color: '#dee0e6',
//       label: t('terrace'),
//     },
//     {
//       id: '6',
//       color: '#134e6f',
//       label: t('wc'),
//     },
//   ];
// };
